import React from 'react';
import times from 'lodash/times';
import { PositionsTableSkeleton } from './components/PositionsTableSkeleton';
import { TableCell, TableRow } from '../../../../../CommonComponents/OPL/Table/Table';
import { Shimmer } from '../../../../../CommonComponents/OPL/Shimmer/Shimmer';

interface PositionsTableLoadingProps {
  isEmbeddedMobile: boolean;
}

export const PositionsTableLoading = ({ isEmbeddedMobile }: PositionsTableLoadingProps) => {
  return (
    <PositionsTableSkeleton isLoading isEmbeddedMobile={isEmbeddedMobile}>
      {times(7).map(i => (
        <TableRow key={i}>
          <TableCell width="40%">
            <Shimmer width="100%" height={20} />
          </TableCell>

          {times(6).map(j => (
            <TableCell key={j} width="10%">
              <Shimmer width="100%" height={20} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </PositionsTableSkeleton>
  );
};
